import {
  Dialog,
  DialogMaxWidth,
  DialogVariant,
  Grid,
  Input,
  InputVariant,
  InputWeight,
  textStyleUtils
} from '@focaldata/cin-ui-components'
import { memo } from 'react'

interface Props {
  targetValue?: string
  savingDisabled: boolean
  onChange: (value: string) => void
  onClose: () => void
  onSave: () => void
}

const AutoSumDialogComponent = ({
  targetValue,
  savingDisabled,
  onChange,
  onClose,
  onSave
}: Props) => {
  const { classes: textClasses, cx: classNames } =
    textStyleUtils.useTextStyles()
  return (
    <Dialog
      open
      title="Set auto-sum validation"
      fullWidth
      maxWidth={DialogMaxWidth.Sm}
      onClose={onClose}
      primaryButtonText="Save"
      primaryButtonDisabled={savingDisabled}
      primaryButtonClick={onSave}
      variant={DialogVariant.SingleButton}
    >
      <Grid display="flex" alignItems="center">
        <p
          className={classNames(
            textClasses.default,
            textClasses.sizeM,
            textClasses.highlightEmphasis,
            textClasses.displayInline
          )}
        >
          Respondents&apos; numeric entries must sum to{' '}
        </p>
        <Grid marginX={1}>
          <Input
            value={targetValue}
            variant={InputVariant.Outlined}
            inputWeight={InputWeight.SemiBold}
            width={80}
            onChange={(e) => onChange(e.target.value)}
            onBlur={(e) => !e.target.value && onChange('100')}
          />
        </Grid>
      </Grid>
      <p
        className={classNames(
          textClasses.default,
          textClasses.sizeMs,
          textClasses.highlightBackground
        )}
        style={{ marginTop: 12 }}
      >
        Note: This will enable numeric entry on all response options.
      </p>
    </Dialog>
  )
}

export default memo(AutoSumDialogComponent)
